import fetch from 'auth/FetchInterceptor';

const sellerService = {};
const api = '/participant';
sellerService.getProfile = async function () {
  try {
    const res = await fetch({
      url: `${api}/profile`,
      method: 'get'
    });

    return res.data;
  } catch (err) {

  }
};

export default sellerService;